module.exports = __webpack_public_path__ + "static/img/6.090d345.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-h5/6.jpg
// module id = 0OSu
// module chunks = 2